import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {

    const errors = {}

    if (!values.pageTitle || values.pageTitle.toString().trim() == "") {
        errors.pageTitle = messages.required;
    } else if (values.pageTitle && values.pageTitle.length > inputTextLimit) {
        errors.pageTitle = messages.limitExceededError;
    }

    let content = values?.content?.replace('<p>', '')?.replace('</p>', '');
    const stripped = values?.content?.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").replace(/\s+/g, "").trim();

    if (!values?.content || content.trim() === "" || !stripped) {
        errors.content = messages.required;
    }

    return errors
}

export default validate;
